// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// Vue.component(Header.name, Header)
// Vue.component(Navbar.name, Navbar)
// Vue.component(TabItem.name, TabItem)
import { i18n } from '@/assets/languages'
import Header from '@/components/Header.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Mint, { InfiniteScroll, Loadmore, MessageBox, Toast } from 'mint-ui'
import 'mint-ui/lib/style.css'
import Vue from 'vue'

import App from './App'
import router from './router'
import store from './store'
import { handleNum } from './utils/qmis'
// 全局注册Bus
import Bus from './utils/vbus'

Vue.component(Loadmore.name, Loadmore)

Vue.$toast = Vue.prototype.$toast = Toast
Vue.$messagebox = Vue.prototype.$messagebox = MessageBox
Vue.$handleNum = Vue.prototype.$handleNum = handleNum
Vue.use(InfiniteScroll)

// 弹出框后面页面禁止滑动
// Vue.prototype.$stopScroll = function (val) {
//   if (val) {
//     document.documentElement.style.overflow = 'hidden'
//   } else {
//     document.documentElement.style.overflow = 'scroll'
//   }
// }

Vue.use(Mint)
Vue.use(ElementUI)
// 注册为全局组件
Vue.component('AppHeader', Header)
Vue.use(Bus)

Vue.config.productionTip = false

let keepRoutes = router.options.routes
  .filter((item) => {
    if (item.meta) {
      return item
    }
  })
  .map((item) => {
    return item.name
  })
console.log(keepRoutes)

router.beforeEach((to, from, next) => {
  console.log(to.name)
  console.log(from.name)
  store.commit('SET_FROM_NAME', from.name)
  let keepAlive = store.state.keepAlive
  if (keepRoutes.indexOf(to.name) > -1) {
    // 判断即将打开的页面是否是需要缓存的
    if (keepAlive.indexOf(to.name) < 0) {
      keepAlive.push(to.name)
    }
    store.commit('SET_KEEP_ALIVE', keepAlive) // 进入页面之前缓存页面
    console.log(store.state.keepAlive)
  }
  // Vue.prototype.$stopScroll()

  next()
})

router.afterEach((to, from, nex) => {
  if (store.state.keepAlive.indexOf(to.name) < 0) {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  }
})

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js